import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-693daf55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "disabled", "readonly", "max", "min", "value", "placeholder", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['label', _ctx.disabled ? 'disabled' : '', _ctx.required ? 'required' : '']),
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 11, _hoisted_2),
    _createElementVNode("input", {
      type: "date",
      id: _ctx.id,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      max: _ctx.max,
      min: _ctx.min,
      value: _ctx.disabled ? '' : _ctx.modelValue,
      placeholder: _ctx.placeholder,
      title: _ctx.title,
      class: "input",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, _hoisted_3)
  ]))
}